import { render, staticRenderFns } from "./AgencyGoalsSettings.vue?vue&type=template&id=4726ea5e"
import script from "./AgencyGoalsSettings.vue?vue&type=script&lang=ts"
export * from "./AgencyGoalsSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports